<template>
  <DataTable
    :value="dataSource"
    data-key="Id"
    v-model:filters="filters"
    filter-display="row"
    show-gridlines
    selection-mode="single"
    edit-mode="row"
    v-model:editing-rows="editingRows"
    state-storage="local"
    scrollable
    scroll-height="80vh"
    paginator
    :loading="false"
    :rows="20"
    :rows-per-page-options="[7, 10, 20, 50]"
    removable-sort
    class="p-datatable-sm"
    v-model:selection="selectedRow"
    @row-edit-save="$emit('row-edit', $event)"
    @row-dblclick="changeNews"
    @row-select="$emit('row-selected', $event)"
  >
    <Column
      v-if="isActiveFild"
      :sortable="isSortable"
      field="Vendor"
      header="Артикул"
      bodyStyle="text-align:left"
      :showFilterMenu="false"
      style="max-width: 8rem"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
    </Column>
    <Column
      :sortable="isSortable"
      field="Header"
      :header="headerSecondaryTitle"
      style="max-width: 18rem"
    >
      <!-- Кастомный заголовок с поиском -->
      <template #header v-if="headerFilterInHeader">
        <div class="header-with-filter">
          <span>{{ headerSecondaryTitle }}</span>
          <InputText
            v-model="headerFilter"
            @input="onHeaderFilterChange"
            placeholder="Поиск"
            class="p-column-filter header-filter"
            style="margin-top: 1rem;"
          />
        </div>
      </template>

      <!-- Фильтр в строке фильтрации -->
      <template #filter="{ filterModel, filterCallback }" v-if="!headerFilterInHeader">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>

      <!-- Пустой слот фильтра, если фильтр в заголовке -->
      <template #filter v-else>
        <div style="display: none;"></div>
      </template>

      <template #body="{ data }">
        <span v-if="headerHtml" v-html="data.Header" />
        <span v-else>{{ data.Header }}</span>
      </template>
    </Column>
    <Column
      v-if="isActiveFild"
      :sortable="isSortable"
      field="DateCreated"
      header="Дата Создания"
      bodyStyle="text-align:left"
      style="max-width: 8rem"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
      <template #body="slotProps">
        {{  formaterDate(slotProps.data.DateCreated) }}
      </template>
    </Column>
    <Column
      v-if="isActiveFild"
      :sortable="isSortable"
      field="PublicationDate"
      header="Дата публикации"
      bodyStyle="text-align:left"
      style="max-width: 8rem"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
      <template #body="slotProps">
        {{  formaterDate(slotProps.data.PublicationDate) }}
      </template>
    </Column>
    <!-- <Column
      :sortable="isSortable"
      field="DefferedDate"
      header="Дата отложенной публикации"
      bodyStyle="text-align:center"
      style="max-width: 8rem"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
      <template #body="slotProps">
        {{  formaterDateTime(slotProps.data.DefferedDate) }}
      </template>
    </Column> -->
    <Column
      v-if="isActiveFild"
      :sortable="directionSortable"
      field="UniversalTagId"
      :header="directionHeader"
      bodyStyle="text-align:left"
      :show-filter-menu="false"
      style="max-width: 12rem"
    >
      <!-- Кастомный заголовок с выпадающим списком -->
      <template #header v-if="directionFilterInHeader">
        <div class="header-with-filter">
          <span>{{ directionHeader }}</span>
          <Dropdown
            v-model="directionFilter"
            @change="onDirectionFilterChange"
            :options="activities"
            option-label="name"
            option-value="id"
            placeholder="Все направления"
            class="p-column-filter header-filter"
            style="min-width: 14rem; margin-top: 0.25rem;"
            :showClear="true"
          >
            <template #option="{ option }">
              <ActivitiesImages
                :typeActivities="option.id"
              />
            </template>
          </Dropdown>
        </div>
      </template>

      <template #body="{ data }">
        <ActivitiesImages
          :typeActivities="data.UniversalTagId"
        />
      </template>

      <!-- Фильтр в строке фильтрации -->
      <template #filter="{ filterModel, filterCallback }" v-if="!directionFilterInHeader">
        <Dropdown
        v-if="visibleDirectionSort"
          v-model="filterModel.value"
          @change="filterCallback()"
          :options="activities"
          option-label="name"
          option-value="id"
          placeholder="Направление"
          class="p-column-filter"
          style="min-width: 14rem;"
          :showClear="true"
        >
          <template #option="{ option }">
            <ActivitiesImages
              :typeActivities="option.id"
            />
          </template>
        </Dropdown>
      </template>

      <!-- Пустой слот фильтра, если фильтр в заголовке -->
      <template #filter v-else>
        <div style="display: none;"></div>
      </template>
    </Column>

    <!-- Новая колонка для статуса группы -->
    <Column
      v-if="isActiveFildAll"
      :sortable="isSortable"
      field="GroupStatusId"
      bodyStyle="text-align:left"
      :show-filter-menu="false"
      style="min-width: 14rem"
    >
      <!-- Кастомный заголовок с выпадающим списком -->
      <template #header>
        <div class="header-with-filter">
          <Dropdown
            v-model="groupStatusFilter"
            @change="onGroupStatusFilterChange"
            :options="groupStatuses"
            option-label="Name"
            option-value="Id"
            placeholder="Все"
            class="p-column-filter header-filter"
            style="min-width: 14rem; margin-top: 0.25rem;"
            :showClear="true"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value" class="flex align-items-center gap-2">
                <div class="group-status-badge" :class="`status-${slotProps.value}`">
                  {{ getGroupStatusName(slotProps.value) }}
                </div>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <div class="flex align-items-center gap-2">
                <div class="group-status-badge" :class="`status-${slotProps.option.Id}`">
                  {{ slotProps.option.Name }}
                </div>
              </div>
            </template>
          </Dropdown>
        </div>
      </template>

      <template #body="{ data }">
        <div class="group-status-badge" :class="`status-${data.GroupStatusId}`">
          {{ getGroupStatusName(data.GroupStatusId) }}
        </div>
      </template>

      <!-- Пустой слот фильтра, так как фильтр в заголовке -->
      <template #filter>
        <div style="display: none;"></div>
      </template>
    </Column>

    <Column
      v-if="isActiveEventsFild"
      :sortable="isSortable"
      field="DateBegin"
      header="Начало обучения"
      bodyStyle="text-align:left"
      style="max-width: 8rem"
    >
      <template #body="slotProps">
        {{  formaterDate(slotProps.data.DateBegin) }}
      </template>
    </Column>
    <Column
      v-if="isActiveEventsFild"
      :sortable="isSortable"
      field="DateEnd"
      header="Конец обучения"
      bodyStyle="text-align:left"
      style="max-width: 8rem"
    >
      <template #body="slotProps">
        {{  formaterDate(slotProps.data.DateEnd) }}
      </template>
    </Column>
    <Column
      v-if="isActiveFild"
      :sortable="isSortable"
      header="Готово к публикации"
      :body-style="{'text-align': 'left'}"
      field="ReadyToPublish"
      :show-filter-menu="false"
      dataType="boolean"
      style="
        min-width: 4rem;
        max-width: 8rem;
      "
    >
      <template #body="slotProps">
        <Checkbox
          v-model="slotProps.data.ReadyToPublish"
          :binary="true"
          disabled
        />
      </template>
      <template #editor="{ data, field }">
        <Checkbox
          v-model="data[field]"
          :binary="true"
          v-if="policiesValid(policies, data.UniversalTagId, 'editing')"
        />
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <TriStateCheckbox
          v-model="filterModel.value"
          @change="filterCallback()"
        />
      </template>
    </Column>
    <Column
      v-if="isActiveEventsFild"
      :sortable="isSortable"
      field="Duration"
      header="Количество часов"
      bodyStyle="text-align:left "
      :showFilterMenu="false"
      style="max-width: 8rem"
    >
    </Column>
    <Column
      v-if="isActiveFild"
      :sortable="isSortable"
      field="Published"
      header="Опубликовано"
      :body-style="{'text-align': 'left'}"
      :show-filter-menu="false"
      style="max-width: 8rem"
    >
      <template #body="slotProps">
        <InputSwitch
          v-model="slotProps.data.Published"
          disabled
        />
      </template>
      <template #editor="{ data, field }">
        <InputSwitch
          v-model="data[field]"
          v-if="policiesValid(policies, data.UniversalTagId, 'publish')"
        />
      </template>
      <template v-if="isSearchShow" #filter="{ filterModel, filterCallback }">
        <TriStateCheckbox
          v-model="filterModel.value"
          @change="filterCallback()"
        />
      </template>
    </Column>
    <Column
      v-if="isActiveFild"
      :row-editor="true"
      style="max-width: 10rem;
      min-width: 6rem"
      body-style="text-align:left"
    />
  </DataTable>
</template>

<script>
import { ref, toRef, reactive, watch, computed } from 'vue'
import { useStore } from 'vuex'

import { formaterDate, formaterDateTime } from '@/helpers/helpFunctions.js'
import { policiesValid } from '@/helpers/policiesValidator'

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import TriStateCheckbox from 'primevue/tristatecheckbox'
import InputSwitch from 'primevue/inputswitch'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'

import ActivitiesImages from '@/components/icons/ActivitiesImages.vue'

import { FilterMatchMode } from 'primevue/api'

export default {
  name: 'ListTable',
  components: {
    DataTable,
    Column,
    InputText,
    TriStateCheckbox,
    InputSwitch,
    Checkbox,
    ActivitiesImages,
    Dropdown
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    policies: {
      type: Array,
      default: () => []
    },
    isActiveFild: {
      type: Boolean,
      default: true
    },
    isActiveEventsFild: {
      type: Boolean,
      default: false
    },
    isSearchShow: {
      type: Boolean,
      default: true
    },
    isSortable: {
      type: Boolean,
      default: true
    },
    disablePolitic: {
      type: Boolean,
      default: true
    },
    directionHeader: {
      type: String,
      default: 'Направление деятельности'
    },
    directionSortable: {
      type: Boolean,
      default: true
    },
    // Новые пропсы для управления фильтрацией в заголовке
    headerFilterInHeader: {
      type: Boolean,
      default: false
    },
    headerSecondaryTitle: {
      type: String,
      default: 'Название'
    },
    directionFilterInHeader: {
      type: Boolean,
      default: false
    },
    groupStatusHeader: {
      type: String,
      default: 'Статус группы'
    },
    groupStatusSortable: {
      type: Boolean,
      default: true
    },
    isActiveFildAll: {
      type: Boolean,
      default: false
    },
    visibleDirectionSort: {
      type: Boolean,
      default: true
    },
    // Рендер названия как HTML (для новостей/товаров с CKEditor в заголовке)
    headerHtml: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const store = useStore()

    const directionFilter = ref(null)
    const headerFilter = ref(null)
    const groupStatusFilter = ref(null)

    // нужно для работы таблицы по документации
    const filters = ref({
      Vendor: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Header: { value: null, matchMode: FilterMatchMode.CONTAINS },
      PublicationDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      DateCreated: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      DefferedDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      UniversalTagId: { value: null, matchMode: FilterMatchMode.EQUALS },
      ReadyToPublish: { value: null, matchMode: FilterMatchMode.EQUALS },
      Published: { value: null, matchMode: FilterMatchMode.EQUALS },
      GroupStatusId: { value: null, matchMode: FilterMatchMode.EQUALS } // Добавлен фильтр для статуса группы
    })

    const editingRows = ref([])

    const selectedRow = ref()
    // нужно для работы таблицы по документации

    const activities = reactive([
      { name: 'Группа компаний', id: 1 },
      { name: 'Обучение', id: 2 },
      { name: 'Производство', id: 3 },
      { name: 'Инжиниринговые услуги', id: 4 },
      { name: 'Программное обеспечение', id: 5 }
    ])

    // Статусы групп - будет отображаться в выпадающем списке
    const groupStatuses = computed(() => {
      return store.getters.getGroupStatuses
    })

    const dataSource = toRef(props, 'data')

    const changeNews = (e) => {
      if (!policiesValid(props.policies, e.data.UniversalTagId, 'editing') && props.disablePolitic) {
        store.dispatch('setShowErrorModal', { Message: 'У Вас нет прав на редактирование' })

        return
      }
      // в том случае если пользователь может редактировать товар/новость
      // то эмитится событие ниже, которе слушается из родительского компонента
      emit('redirectToEditor', e.data.Id)
    }

    // Функция для получения названия статуса по ID
    const getGroupStatusName = (statusId) => {
      const status = groupStatuses?.value?.find(s => s.Id === statusId)
      return status ? status.Name : 'Неизвестно'
    }

    // Обработчик изменения фильтра направления (когда фильтр в заголовке)
    const onDirectionFilterChange = () => {
      filters.value.UniversalTagId.value = directionFilter.value
    }

    // Обработчик изменения фильтра заголовка (когда фильтр в заголовке)
    const onHeaderFilterChange = () => {
      filters.value.Header.value = headerFilter.value
    }

    // Обработчик изменения фильтра статуса группы (когда фильтр в заголовке)
    const onGroupStatusFilterChange = () => {
      filters.value.GroupStatusId.value = groupStatusFilter.value
    }

    // Синхронизация значения фильтров при изменении filters (для обратной совместимости)
    watch(() => filters.value.UniversalTagId.value, (newValue) => {
      if (props.directionFilterInHeader) {
        directionFilter.value = newValue
      }
    })

    watch(() => filters.value.Header.value, (newValue) => {
      if (props.headerFilterInHeader) {
        headerFilter.value = newValue
      }
    })

    watch(() => filters.value.GroupStatusId.value, (newValue) => {
      groupStatusFilter.value = newValue
    })

    return {
      filters,
      policiesValid,
      editingRows,
      dataSource,
      formaterDate,
      changeNews,
      selectedRow,
      activities,
      groupStatuses,
      formaterDateTime,
      directionFilter,
      headerFilter,
      groupStatusFilter,
      onDirectionFilterChange,
      onHeaderFilterChange,
      onGroupStatusFilterChange,
      getGroupStatusName
    }
  }
}
</script>

<style>
.p-dropdown .p-inputtext {
  border: none;
  display: flex;
  align-items: center;
}

.p-dropdown-panel .p-dropdown-items {
  padding: 0.5rem 0;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  color: #495057;
  background: #E3F2FD;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  margin: 0;
  padding: 0.5rem 1rem;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

</style>

<style lang="scss" scoped>
:deep(.p-datatable-wrapper) {
  max-height: calc(100vh - 170px) !important;

  &::-webkit-scrollbar {
    height: 5px; /* толщина горизонтального скролла */
    width: 5px; /* толщина вертикального скролла */
    background-color: #ffffff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #00ABEC;

    &:hover {
      background-color: #00ABEC;
    }
  }
}
:deep(.p-column-filter-row .p-column-filter-menu-button) {
  display: none;
}
:deep(.p-column-filter-row .p-column-filter-clear-button) {
  display: none;
}

/* Стили для заголовка с фильтром */
.header-with-filter {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

:deep(.header-filter) {
  .p-dropdown-label {
    font-size: 0.875rem;
  }

  &.p-inputtext {
    font-size: 0.875rem;
  }
}

/* Стили для бейджей статусов групп */
.group-status-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  display: inline-block;

  &.status-1 {
    background-color: #e8f5e8;
    color: #2e7d32;
    border: 1px solid #c8e6c9;
  }

  &.status-2 {
    background-color: #e3f2fd;
    color: #1565c0;
    border: 1px solid #bbdefb;
  }

  &.status-3 {
    background-color: #f5f5f5;
    color: #616161;
    border: 1px solid #e0e0e0;
  }

  &.status-4 {
    background-color: #ffebee;
    color: #c62828;
    border: 1px solid #ffcdd2;
  }
}

:deep(.p-datatable-thead) {
  th {
    font-weight: 400 !important;
    font-size: 16px !important;
    color: #787878 !important;
    background-color: #E6E6E6 !important;
    border-right: 1px solid #787878 !important;
    border-bottom: none !important;

    &:last-child {
      border-right: none !important;
    }
  }
}
:deep(.p-datatable-tbody) {
  td {
    font-weight: 400 !important;
    font-size: 16px !important;
    color: #000000 !important;
    border: 1px solid #E6E6E6 !important;
  }
  tr.p-highlight {
    background: #DEDEDE !important;
    &:focus, &:active {
      outline: none !important;
      border: none !important;
    }
  }
}
:deep(.p-inputtext) {
  border: 1px solid #000000;
  width: 100% !important;
  padding: 6px 12px !important;
  &:hover {
    border-color: #000000 !important;
  }
  &:focus {
    box-shadow: none !important;
    border-color: #000000 !important;
  }
}
:deep(.p-dropdown) {
  border: 1px solid #C8C8C8 !important;
  background-color: #F5F5F5 !important;
  /* Состояние фокуса */
  &.p-focus {
    box-shadow: none !important;
    outline: none !important;
    border-color: #000000 !important;
  }
  /* Состояние ховера */
  &:not(.p-disabled):hover {
    border-color: #000000 !important;
  }
  /* Внутренние элементы */
  .p-dropdown-label {
    &:focus {
      box-shadow: none !important;
      outline: none !important;
    }
  }
  /* Триггер (стрелка) */
  .p-dropdown-trigger {
    &:focus {
      outline: none !important;
    }
  }
}

:deep(.header-with-filter) {
  width: 100%;
  .p-dropdown {
    position: relative !important;
    width: 100% !important;
    min-width: 100% !important;
    font-size: 16px !important;
    .p-dropdown-trigger {
      position: absolute;
      right: 0;
      top: calc(50% - 9px);
    }
  }
  .p-inputtext {
    width: 100% !important;
    min-width: 100% !important;
    font-size: 16px !important;
  }
}
:deep(.p-dropdown-item) {
  .p-highlight {
    background-color: #DEDEDE !important;
    &:focus, &:active {
      outline: none !important;
      border: none !important;
    }
  }
}
:deep(.p-paginator) {
  background-color: #F5F5F5;
  .p-highlight {
    background-color: #00ABEC !important;
    color: #ffffff !important;
  }
  .p-paginator-page {
    color: #000000;
  }

  .p-dropdown-item {
    width: 100%;
    .p-highlight {
      background: #DEDEDE !important;
      &:focus, &:active {
        outline: none !important;
        border: none !important;
      }
    }
  }
}
:deep(.p-sortable-column-icon) {
  display: none !important;
}
:deep(.p-sortable-column) {
  position: relative;
  .p-column-title {
    &::after {
      content: '';
      display: inline-block;
      width: 16px;
      height: 20px;
      margin-left: 5px;
      background-image: url('/public/img/icons/SortIcon.svg');
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
    }
  }
}

:deep(.p-inputswitch-checked) {
  .p-inputswitch-slider {
    background: #00ABEC !important;
  }
}
:deep(.p-inputswitch-slider) {
  background: #E6E6E6!important;
  height: 12px;
}
:deep(.p-inputswitch) {
  .p-inputswitch-slider {

    &::before {
      margin-top: -0.7rem !important;
      border: 2px solid #00ABEC !important;
    }

    &.p-highlight {
      background: #00ABEC !important; // Цвет при включённом состоянии (checked)
    }
  }
}

:deep(.p-checkbox-box.p-highlight) {
  background-color: #00ABEC !important;
  border-color: #00ABEC !important;
}
:deep(.p-checkbox .p-checkbox-box) {
  border-radius: 5px;
  border: 2px solid #787878;
}

:deep(.p-row-editor-save .p-row-editor-save-icon),
:deep(.p-row-editor-cancel .p-row-editor-cancel-icon) {
  fill: #787878 !important;
}

:deep(.p-row-editor-save .p-row-editor-save-icon path),
:deep(.p-row-editor-cancel .p-row-editor-cancel-icon path) {
  fill: #787878 !important;
}
:deep(.p-row-editor-save),
:deep(.p-row-editor-cancel) {
  border: 2px solid #787878 !important;
  width: 25px !important;
  height: 25px !important;

  &:hover {
    border-color: #00ABEC !important;
    path {
      fill: #00ABEC !important;
    }
  }

  &:focus {
    box-shadow: none !important;
  }
}
</style>
